import React, {useEffect} from 'react';
import Lottie from 'lottie-react-native';
import analytics from '@react-native-firebase/analytics';

import {Container, Content, Description, Header, Title} from './styles';

import {api, apiFipe, tokenFipe} from '../../../services/api';
import {useNavigation, useRoute} from '@react-navigation/native';
import {FipeResponseDTO} from '../../../dtos/FipeDTO';

interface Params {
  placa: string;
}

export function LoadingFipe() {
  const navigation = useNavigation();
  const route = useRoute();

  const {placa} = route.params as Params;
  const animationSource = _WEB_
    ? null
    : require('../../../assets/images/json/93387-car-insurance-offers-loading-page.json');

  useEffect(() => {
    async function criaConsulta(state: string) {
      await api.post('/criaConsultas', {
        consulta: {
          placa: placa,
          estado: state,
          finalidade: 'fipe',
        },
      });
    }
    async function fetchFipe() {
      await apiFipe
        .post('/getplacafipe', {
          placa: placa,
          token: tokenFipe,
        })
        .then(({data}) => {
          const {codigo, informacoes_veiculo} = data as FipeResponseDTO;
          if (codigo === 1) {
            analytics().logEvent('busca_fipe_sucesso');
            criaConsulta(informacoes_veiculo.uf);
            return navigation.navigate('FipeDetails', {
              data,
            });
          }
          if (codigo === 763) {
            analytics().logEvent('busca_fipe_erro');
            return navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.navigate('Initial'),
              buttonText: 'Ir para a tela inicial',
              closeIconAction: () => navigation.navigate('Initial'),
              text: 'Placa não encontrada, verifique e tente novamente.',
              title: 'Ocorreu um problema',
            });
          }
          if (codigo === 763 || codigo === 759) {
            analytics().logEvent('busca_fipe_erro');
            return navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.navigate('Initial'),
              buttonText: 'Ir para a tela inicial',
              closeIconAction: () => navigation.navigate('Initial'),
              text: 'Veículo não encontrado. Verifique a placa e tente novamente.',
              title: 'Ocorreu um problema',
            });
          }

          return navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
            title: 'Ocorreu um problema',
          });
        })
        .catch(() => {
          analytics().logEvent('busca_fipe_erro');
          navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Ir para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
            title: 'Ocorreu um problema',
          });
        });
    }
    fetchFipe();
  }, []);

  return (
    <Container>
      <Header>
        {animationSource && (
          <Lottie
            source={animationSource}
            autoPlay
            style={{
              height: '100%',
              flex: 1,
              width: '100%',
            }}
            resizeMode="cover"
          />
        )}
      </Header>
      <Content>
        <Title>Estamos consultando a placa informada.</Title>
        <Description>Por favor, aguarde alguns instantes.</Description>
      </Content>
    </Container>
  );
}
